<template>
  <div class="top3 pt-3">
    <div class="row g-0">
      <div class="col-12 col-md-8">
        <div class="row g-0">
          <div class="col-12 col-md-12 col-lg-4">
            <div class="card" :class="{ 'is-flipped': isFlippedTop(index) }">
              <div class="card-front">
                <div class="ribbon-wrapper">
                  <div class="ribbon">Kleinster Preis</div>
                </div>
                <div class="cardHead my-2">
                  <h5 class="card-title text-start mt-3 mx-2">
                    {{ this.lowestPrice.amazonNamenSuche }}
                  </h5>
                </div>
                <div class="img_center">
                  <section id="splide-top-1" class="splide" aria-label="Beautiful Images">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.lowestPrice.bild_url" alt="Product Image" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsLowestPrice()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section id="thumbnail-splide-top-1" class="splide">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.lowestPrice.bild_url" alt="Product Image" />

                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsLowestPrice()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>

                <div class="card-body">
                  <div class="chart-container d-flex justify-content-center align-items-center">
                    <canvas id="chart-top-1"></canvas>
                  </div>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.paneltyp }} </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.horizontalPixel }}x{{ lowestPrice.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>


                  <button class="datasheet-button" @click="flipCardTop(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                  </button>
                </div>

                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ lowestPrice.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ formatPreis(lowestPrice.preisAmazonNeu) }} €</span><br />
                        </div>
                        <a :href="this.lowestPrice.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn13 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <TopThreeDatenblattMod :product="lowestPrice" />
                  <button class="datasheet-button" @click="flipCardTop(index)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i> Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-4">
            <div class="card" :class="{ 'is-flipped': isFlippedTop2(index) }">
              <div class="card-front">
                <div class="ribbon-wrapper">
                  <div class="ribbon">Höchste Bewertung</div>
                </div>
                <div class="cardHead my-2">
                  <h5 class="card-title text-start mt-3 mx-2">
                    {{ bestRating.amazonNamenSuche }}
                  </h5>
                </div>
                <div class="img_center">
                  <section id="splide-top-2" class="splide" aria-label="Beautiful Images">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.bestRating.bild_url" alt="Product Image" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestRating()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section id="thumbnail-splide-top-2" class="splide">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.bestRating.bild_url" alt="Product Image" />

                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestRating()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>

                <div class="card-body">
                  <div class="chart-container d-flex justify-content-center align-items-center">
                    <canvas id="chart-top-2"></canvas>
                  </div>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.paneltyp }} </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.horizontalPixel }}x{{ bestRating.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button class="datasheet-button" @click="flipCardTop3(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                  </button>
                </div>

                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ bestRating.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price">{{ formatPreis(bestRating.preisAmazonNeu) }} €</span><br />
                        </div>
                        <a :href="this.bestRating.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn13 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <TopThreeDatenblattMod :product="bestRating" />
                  <button class="datasheet-button" @click="flipCardTop3(index)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i> Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-4">
            <div class="card" :class="{ 'is-flipped': isFlippedTop3(index) }">


              <div class="card-front">
                <div class="ribbon-wrapper">
                  <div class="ribbon">PL-Sieger</div>
                </div>
                <div class="cardHead my-2">
                  <h5 class="card-title text-start mt-3 mx-2">
                    {{ this.bestAmazon.amazonNamenSuche }}
                  </h5>
                </div>
                <div class="img_center">
                  <section id="splide-top-3" class="splide" aria-label="Beautiful Images">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="bestAmazon.bild_url" alt="Product Image" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestAmazon()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section id="thumbnail-splide-top-3" class="splide" aria-label="The carousel with thumbnails.">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="bestAmazon.bild_url" alt="Thumbnail" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestAmazon()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Thumbnail" />
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>

                <div class="card-body">
                  <div class="chart-container d-flex justify-content-center align-items-center">
                    <canvas id="chart-top-3"></canvas>
                  </div>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.paneltyp }} </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.horizontalPixel }}x{{ bestAmazon.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button class="datasheet-button" @click="flipCardTop4(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                  </button>
                </div>

                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ bestAmazon.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price">{{ formatPreis(bestAmazon.preisAmazonNeu) }} €</span><br />
                        </div>
                        <a :href="this.bestAmazon.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn13 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-back">
                <div class="card-body">
                  <TopThreeDatenblattMod :product="bestAmazon" />
                  <button class="datasheet-button" @click="flipCardTop4(index)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i> Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-4 d-flex justify-content-center">
        <div class="rightBox">
          <div class="card2 text-center">
            <div class="card shadow-sm mb-4">
              <div class="row g-0">
                <div class="col-12 col-md-8 col-lg-12">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <img
                        src="/wp-content/plugins/monitor-berater/logo_small_icon_only.png"
                        alt="User Avatar" class="rounded-circle me-3" style="width: 40px; height: 40px; border: 2px solid #ccc;">
                      <h4 class="h6 mb-0 text-secondary fw-semibold text-start">Wieso diese Monitore zu dir passen?</h4>
                    </div>

                    <p class="text-muted small mb-2 text-start">Deine persönliche Auswahl</p>

                    <div class="d-grid gap-3">
                      <div v-for="(text, idx) in explanations" :key="idx"
                        class="p-3 rounded shadow-sm bg-success bg-opacity-10 hover-shadow transition">
                        <p class="small mb-0" style="color:#15803d">
                          {{ text }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="position-relative d-inline-block w-100 tooltip-container">
                <div class="d-flex align-items-start p-2 mx-n2 rounded-lg hover-bg transition-colors">
                  <span class="flex-shrink-0 me-2 text-primary group-hover-text transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="1.5" class="icon-size">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
                    </svg>
                  </span>
                  
                  <p class="mb-0 text-secondary small lh-base text-start">
                    Wieso wir teilweise auch "Gaming-Monitore" für die Office-Verwendungen empfehlen?
                  </p>
                </div>

                <div class="tooltip-content text-white bg-dark p-3 rounded-xl shadow-lg" role="tooltip">
                  Gaming-Monitore sind vielseitig und leistungsstark und daher nicht nur für Gamer interessant. Dank
                  ihrer Spezifikationen eignen sie sich oftmals auch für Office-Aufgaben und ermöglichen ein angenehmes
                  Arbeiten. Wichtig zu wissen: Während Gaming-Monitore problemlos als Office-Monitore genutzt werden
                  können, erfüllen klassische Office-Monitore nicht die Anforderungen, die für ein optimales
                  Gaming-Erlebnis nötig sind.
                  <div class="tooltip-arrow"></div>
                </div>
              </div>
            </div>
<div class="card card-share">
  <div class="card-body text-center">
    <h3 class="h6 mb-3">Ergebnis teilen</h3>
    <p class="text-muted small mb-4">
      Teile jetzt deine persönliche Monitor-Auswahl mit Freunden, Bekannten oder Kollegen!
    </p>

    <div class="mt-1 mb-3 d-flex justify-content-center gap-3">
      <a :href="whatsappUrl" target="_blank" rel="noopener">
        <i class="bi bi-whatsapp share-icon whatsapp"></i>
      </a>
            <a :href="redditUrl" target="_blank" rel="noopener">
        <i class="bi bi-reddit share-icon reddit"></i>
      </a>
      <a :href="twitterUrl" target="_blank" rel="noopener">
        <i class="bi bi-twitter share-icon twitter"></i>
      </a>
      <a :href="facebookUrl" target="_blank" rel="noopener">
        <i class="bi bi-facebook share-icon facebook"></i>
      </a>
      <a :href="emailUrl">
        <i class="bi bi-envelope share-icon email"></i>
      </a>
       
    <div class="copy-link-wrapper position-relative d-inline-block">
    
    <div
      v-if="copied"
      class="copy-notification position-absolute top-0 start-50 translate-middle-x bg-dark text-white px-2 py-1 rounded"
      style=" white-space: nowrap;"
    >
      Link zum Teilen kopiert!
    </div>

    <button @click="copyLink" class="btn p-0">
      <i class="bi bi-clipboard share-icon clipboard"></i>
    </button>
  </div>
    </div>

    <button @click="$emit('reset')" class="datasheet-button">
      Neue Beratung starten
    </button>
  </div>
</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>



<script>
import DatenblattMod from "./DatenblattMod.vue";
import TopThreeDatenblattMod from "./TopThreeDatenblattMod.vue";
import Feedback from "./Feedback.vue";
export default {
  components: {
    DatenblattMod,
    TopThreeDatenblattMod,
    Feedback
  },
  data() {
    return {
      openIndex: 0,
      copied: false,
      _timeoutId: null,
      flippedCards2: [],
      flippedCards3: [],
      flippedCards4: [],
    }
  },
    props: {
    lowestPrice: { type: Object, required: true },
    bestRating: { type: Object, required: true },
    bestAmazon: { type: Object, required: true },
    detailsContent: { type: Array, default: () => [] },
    explanations: { type: Array, default: () => [] },
    example: { type: Boolean, default: false },
    shareableLink:  { type: String, default: null },
  },
  emits: [
    'generate-share',
    'copy-share',
    'reset'
  ],

      created() {
    if (!this.shareableLink) {
      this.$emit('generate-share');
    }
  },

    mounted() {
    if (!this.shareableLink) {
      this.$emit('generate-share')
    }
  },

    computed: {
    twitterUrl() {
      const url  = encodeURIComponent(this.shareableLink || '')
      const text = encodeURIComponent('Schau dir meine Monitorauswahl an!')
      return `https://twitter.com/intent/tweet?url=${url}&text=${text}`
    },
    whatsappUrl() {
      const msg = encodeURIComponent('Schau dir meine Monitorauswahl an: ' + this.shareableLink)
      return `https://api.whatsapp.com/send?text=${msg}`
    },
    facebookUrl() {
      const url = encodeURIComponent(this.shareableLink || '')
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    },
    redditUrl() {
      const url   = encodeURIComponent(this.shareableLink || '')
      const title = encodeURIComponent('Meine Monitorauswahl')
      return `https://www.reddit.com/submit?url=${url}&title=${title}`
    },
    emailUrl() {
      const subject = encodeURIComponent('Monitor-Tipps für dich')
      const body    = encodeURIComponent(
        `Hallo,

schau dir mal diese Monitor-Auswahl an:
${this.shareableLink}

Viele Grüße!`
      )
      return `mailto:?subject=${subject}&body=${body}`
    }
  },

  methods: {
      async copyLink() {
      try {
        const url = window.location.href;
        await navigator.clipboard.writeText(url);
        this.copied = true;
                if (this._timeoutId) {
          clearTimeout(this._timeoutId);
        }
        this._timeoutId = setTimeout(() => {
          this.copied = false;
          this._timeoutId = null;
        }, 2000);
        this.$emit('copied', url);
      } catch (err) {
      }
    },

    formatPreis(preis) {
      if (!preis) return '';
      return parseFloat(preis).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    flipCardTop(index) {
      const cardIndex = this.flippedCards2.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards2.push(index);
      } else {
        this.flippedCards2.splice(cardIndex, 1);
      }
    },

    flipCardTop3(index) {
      const cardIndex = this.flippedCards3.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards3.push(index);
      } else {
        this.flippedCards3.splice(cardIndex, 1);
      }
    },

    flipCardTop4(index) {
      const cardIndex = this.flippedCards4.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards4.push(index);
      } else {
        this.flippedCards4.splice(cardIndex, 1);
      }
    },

    isFlippedTop(index) {
      return this.flippedCards2.includes(index);
    },

    isFlippedTop2(index) {
      return this.flippedCards3.includes(index);
    },

    isFlippedTop3(index) {
      return this.flippedCards4.includes(index);
    },

    getImageUrlsLowestPrice() {

      return this.lowestPrice.picVariants.split(';');
    },

    getImageUrlsBestRating() {

      return this.bestRating.picVariants.split(';');
    },

    getImageUrlsBestAmazon() {

      return this.bestAmazon.picVariants.split(';');
    },


    handleSummaryClick(index) {

      this.openIndex = this.openIndex === index ? -1 : index;

    },
    renderChartTop(ctx, prod) {

      const width = window.innerWidth;

      let barThickness, borderWidth, borderRadius;

      if (width >= 2560) {
        barThickness = 50;
        borderWidth = 0.6;
        borderRadius = 5;
      } else if (width >= 1920) {
        barThickness = 38;
        borderWidth = 0.6;
        borderRadius = 5;
      } else {
        barThickness = 38;
        borderWidth = 0.6;
        borderRadius = 5;
      }

      const drawCategoryLabels = {
        id: 'drawCategoryLabels',
        afterDatasetsDraw(chart) {
          const ctx = chart.ctx;
          ctx.save();
          ctx.font = '16px ${bsSans}';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'left';
          ctx.textBaseline = 'bottom';


          const meta0 = chart.getDatasetMeta(0);

          chart.data.labels.forEach((label, i) => {
            const bar = meta0.data[i];
            const x = chart.chartArea.left;
            const y = bar.y - (bar.height / 2);
            ctx.fillText(label, x, y);
          });

          ctx.restore();
        }
      };


new Chart(ctx, {
  type: 'bar',
  data: {
    labels: ['Gaming', 'Office', 'Editing'],
    datasets: [
      {
        // Dataset 0: 100%-Hintergrund (ohne datalabels)
        data: [10,10,10],
        backgroundColor: 'rgba(237, 237, 237, 0.3)',
        barThickness: 25,
        borderRadius: 25,
        borderWidth: 0.8,
        borderColor: '#333',
        borderSkipped: false,
        order: 0,
        grouped: false,
        categoryPercentage:1,
        barPercentage:1,
        
      },
      {
        // Dataset 1: Prozentbalken + DataLabels ganz normal rechts
        data: [
          +((prod.pcGamingVal / 10).toFixed(1)),
          +((prod.officeVal   / 10).toFixed(1)),
          +((prod.editingVal  / 10).toFixed(1))
        ],
        backgroundColor: ['rgba(255, 166, 166, 1)','rgba(166, 188, 255, 1)','rgba(255, 253, 125, 1)'],
        borderColor: '#333',
        borderWidth: { top: 1, bottom: 1, left: 0, right: 1 },
        barThickness: 25,
        borderRadius: 10,
        borderSkipped: false,
        order: 1,
        grouped: false,
        categoryPercentage:1,
        barPercentage:1,
        datalabels: {
          display: true,
          anchor: 'center',
          align:  'right',
          color: '#333',
          font: { size: 20},
          clamp: false
        }
      }
    ]
  },

  plugins: [ ChartDataLabels, drawCategoryLabels ],

  options: {
  responsive: true,           // Chart passt sich der Größe des Canvas-Containers an
  maintainAspectRatio: false, // erlaubt es, die Höhe unabhängig von der Breite zu steuern
  layout: { padding: { left: 20, right: 20, top: 10} },
  indexAxis: 'y',
  plugins: {
    legend:  { display: false },
    tooltip: { filter: item => item.datasetIndex === 1 },
    datalabels: {
      display: ctx => ctx.datasetIndex === 1,
      anchor: 'center',
      align:  'right',
      color: '#333',
      font: { size: 18 },
      clamp: false
    }
  },
  scales: {
    y: { display: false },
    x: { display: false, min:0, max:10 }
  }
}
});
    }
  },
  mounted() {
    const charttop1 = 'chart-top-1';
    const ctxtop1 = document.getElementById(charttop1).getContext('2d');

    const charttop2 = 'chart-top-2';
    const ctxtop2 = document.getElementById(charttop2).getContext('2d');

    const charttop3 = 'chart-top-3';
    const ctxtop3 = document.getElementById(charttop3).getContext('2d');

    this.renderChartTop(ctxtop1, this.lowestPrice);
    this.renderChartTop(ctxtop2, this.bestRating);
    this.renderChartTop(ctxtop3, this.bestAmazon);


    const mainSplideTop1 = 'splide-top-1';
    const mainSplideElementTop1 = document.getElementById(mainSplideTop1);

    const thumbnailSplideTop1 = 'thumbnail-splide-top-1';
    const thumbnailSplideElementTop1 = document.getElementById(thumbnailSplideTop1);

    const mainSplideTop2 = 'splide-top-2';
    const mainSplideElementTop2 = document.getElementById(mainSplideTop2);

    const thumbnailSplideTop2 = 'thumbnail-splide-top-2';
    const thumbnailSplideElementTop2 = document.getElementById(thumbnailSplideTop2);

    const mainSplideTop3 = 'splide-top-3';
    const mainSplideElementTop3 = document.getElementById(mainSplideTop3);

    const thumbnailSplideTop3 = 'thumbnail-splide-top-3';
    const thumbnailSplideElementTop3 = document.getElementById(thumbnailSplideTop3);

    const mainSplide1 = new Splide(mainSplideElementTop1, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails1 = new Splide(thumbnailSplideElementTop1, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    const mainSplide2 = new Splide(mainSplideElementTop2, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails2 = new Splide(thumbnailSplideElementTop2, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    const mainSplide3 = new Splide(mainSplideElementTop3, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails3 = new Splide(thumbnailSplideElementTop3, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    mainSplide1.sync(thumbnails1);
    mainSplide1.mount();
    thumbnails1.mount();

    mainSplide2.sync(thumbnails2);
    mainSplide2.mount();
    thumbnails2.mount();

    mainSplide3.sync(thumbnails3);
    mainSplide3.mount();
    thumbnails3.mount();
  }
};
</script>

<style>
.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  position: relative;
  display: flex;
}

.card.card-share {
  background: linear-gradient(
    120deg,
    #fcf5eb2e 0%,
    #f0ebe5 50%,
    #e6e1dc8f 100%
  );
}



.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}

.card-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background-color: #fff;
  border-radius: 10px;
  transform: rotateY(180deg);
}

.label-data-front {
  color: #999
}

.btn13 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
}

.icon-margin-right {
  margin-right: 8px;
}

.highlights {
  color: var(--default-black, #222);
  background: #b9d1ff;
  position: relative;
  border: 1px solid #222222;
  border-left: none;
  font-weight: 500;
  margin-bottom: 0;
}

.specs {
  display: flex;
  flex-wrap: wrap;
}

.spec-item {
  flex: 1 0 200px;
  margin: 10px;
  border: 1px solid #222;
  background: #121212;
  border-radius: 12px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.spec-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.spec-item::before {
  content: "";
  position: absolute;
  top: -75px;
  right: -75px;
  width: 128px;
  height: 128px;
  background-color: #f9b23478;
  border-radius: 50%;
}

.icon-black {
  color: black !important;
}

.spec-item:nth-child(2n)::before {
  background-color: #3ecd5e5e;
}

.spec-item:nth-child(3n)::before {
  background-color: #e4400261;
}

.spec-item:nth-child(4n)::before {
  background-color: #952aff66;
}

.spec-item:nth-child(5n)::before {
  background-color: #cd3e9462;
}

.spec-item:nth-child(6n)::before {
  background-color: #4c49ea83;
}

.spec-item>* {
  position: relative;
  z-index: 2;
  color: #fff;
}

.ribbon-wrapper {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 10;
}

.ribbon {
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #040404;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: relative;
  padding: 7px 0;
  left: -5px;
  top: 45px;
  width: 200px;
  background-color: rgba(244, 239, 234, 0.7);
  border: 0.8px solid;
}

.rightBox {
  width: 60%
}

.icon-size {
  width: 1.5rem;
  height: 1.5rem;
}

.tooltip-container {
  cursor: help;
}

.tooltip-content {
  position: absolute;
  width: 18rem;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  transition-delay: 0.1s;
  z-index: 1000;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-container:hover .tooltip-content {
  opacity: 1;
  visibility: visible;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-top: 0.5rem solid #212529;
}

.rounded-xl {
  border-radius: 0.75rem !important;
}

.shadow-lg {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.hover-bg:hover {
  background-color: rgba(13, 110, 253, 0.1);
}

.group-hover-text:hover {
  color: #0b5ed7;
}

.rightBox .card2 {
  margin-top: 5px;
}

@media (max-width: 576px) {
  .rightBox {
    width: 100%;
    padding: 0 1rem; 
  }
}

    .share-icon {
    font-size: 1.5rem;      
    transition: opacity .2s;
  }
  .share-icon:hover {
    opacity: 0.8;
  }

  .twitter   { color: #1DA1F2; }
  .facebook  { color: #1877F2; }
  .whatsapp  { color: #25D366; }
  .linkedin  { color: #0077B5; }
  .pinterest { color: #E60023; }
  .reddit    { color: #FF4500; }
  .telegram  { color: #0088CC; }
  .email     { color: #EA4335; }
  .clipboard { color: #6c757d; } 
</style>